<template>
  <div>
    <div class="constants_layout">
      <img width="60%" src="../assets/images/big_logo.png">
    </div>
    <div class="icp_layout">
      <a href="https://beian.miit.gov.cn/" target="_blank" sign-trs-href="https://beian.miit.gov.cn/">京ICP备2023023501号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      // msg: 'Welcome to XiJian Technology'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.constants_layout{
  margin-top: 200px;
}
.icp_layout {
  height: 40px;
  width: 100%;
  line-height: 40px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #a55bb0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icp_layout a {
  align-self: center;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue